import React, { useEffect, useState, useCallback } from 'react';

const API_URL = process.env.REACT_APP_API_URL || (window.location.origin + '/api');

const ROLE_LABEL = {
  admin: 'Administrador', technician: 'Soporte', manager: 'Gerente',
  viewer: 'Visor', usuario: 'Usuario', seguridad: 'Seguridad',
};

function statusColor(code) {
  if (code >= 500) return { color: 'var(--red)', bg: 'var(--red-dim)' };
  if (code >= 400) return { color: '#854f0b', bg: 'var(--amber-dim)' };
  return { color: 'var(--green)', bg: 'var(--green-dim)' };
}

function fmt(ts) {
  try { return new Date(ts).toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }); }
  catch { return ts; }
}

const LIMIT = 50;

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(true);
  const [actions, setActions] = useState([]);
  const [q, setQ] = useState('');
  const [action, setAction] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    fetch(`${API_URL}/audit-log/actions`, { headers })
      .then(r => r.json()).then(d => Array.isArray(d) && setActions(d)).catch(() => {});
  }, []); // eslint-disable-line

  const load = useCallback(async (off = 0) => {
    setLoading(true);
    try {
      const p = new URLSearchParams({ limit: LIMIT, offset: off });
      if (q) p.set('q', q);
      if (action) p.set('action', action);
      if (from) p.set('from', from);
      if (to) p.set('to', to);
      const r = await fetch(`${API_URL}/audit-log?${p}`, { headers });
      const d = await r.json();
      setRows(d.rows || []); setTotal(d.total || 0); setOffset(off);
    } catch { setRows([]); }
    finally { setLoading(false); }
  }, [q, action, from, to]); // eslint-disable-line

  useEffect(() => { load(0); }, []); // eslint-disable-line

  const th = { textAlign: 'left', padding: '10px 12px', fontSize: 12, fontWeight: 500, color: 'var(--ink-2)', textTransform: 'uppercase', letterSpacing: 0.4, borderBottom: '1px solid var(--border)', whiteSpace: 'nowrap' };
  const td = { padding: '10px 12px', fontSize: 13, color: 'var(--ink)', borderBottom: '1px solid var(--bg)', verticalAlign: 'top' };
  const inp = { padding: '8px 10px', border: '1px solid var(--border-2)', borderRadius: 8, fontSize: 13, background: 'var(--surface)' };

  return (
    <div className="page">
      <div style={{ marginBottom: 6 }}>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 600 }}>Registro de actividad</h1>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: 'var(--ink-2)' }}>
          Acciones realizadas por los usuarios (crear, editar, eliminar, login). Retención 1 año.
        </p>
      </div>

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end', margin: '18px 0' }}>
        <div style={{ flex: 1, minWidth: 200 }}>
          <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-2)', display: 'block', marginBottom: 4 }}>BUSCAR</label>
          <input style={{ ...inp, width: '100%' }} value={q} onChange={e => setQ(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && load(0)} placeholder="usuario, acción o ruta" />
        </div>
        <div>
          <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-2)', display: 'block', marginBottom: 4 }}>ACCIÓN</label>
          <select style={inp} value={action} onChange={e => setAction(e.target.value)}>
            <option value="">Todas</option>
            {actions.map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-2)', display: 'block', marginBottom: 4 }}>DESDE</label>
          <input type="date" style={inp} value={from} onChange={e => setFrom(e.target.value)} />
        </div>
        <div>
          <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-2)', display: 'block', marginBottom: 4 }}>HASTA</label>
          <input type="date" style={inp} value={to} onChange={e => setTo(e.target.value)} />
        </div>
        <button onClick={() => load(0)}
          style={{ padding: '8px 18px', background: 'var(--ink)', color: 'var(--surface)', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
          Filtrar
        </button>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={th}>Fecha / hora</th>
                <th style={th}>Usuario</th>
                <th style={th}>Rol</th>
                <th style={th}>Acción</th>
                <th style={th}>Método</th>
                <th style={th}>Ruta</th>
                <th style={th}>Estado</th>
                <th style={th}>IP</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td style={{ ...td, textAlign: 'center', color: 'var(--ink-3)', padding: 30 }} colSpan={8}>Cargando…</td></tr>
              ) : rows.length === 0 ? (
                <tr><td style={{ ...td, textAlign: 'center', color: 'var(--ink-3)', padding: 30 }} colSpan={8}>Sin registros para los filtros seleccionados.</td></tr>
              ) : rows.map(r => {
                const sc = statusColor(r.status_code);
                return (
                  <tr key={r.id}>
                    <td style={{ ...td, whiteSpace: 'nowrap' }}>{fmt(r.created_at)}</td>
                    <td style={td}>
                      <div style={{ fontWeight: 500 }}>{r.user_name || '—'}</div>
                      <div style={{ fontSize: 12, color: 'var(--ink-2)' }}>{r.user_email || ''}</div>
                    </td>
                    <td style={td}>{ROLE_LABEL[r.user_role] || r.user_role || '—'}</td>
                    <td style={td}>{r.action}</td>
                    <td style={{ ...td, fontFamily: 'monospace', fontSize: 12 }}>{r.method}</td>
                    <td style={{ ...td, fontFamily: 'monospace', fontSize: 12, color: 'var(--ink-2)', maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={r.path}>{r.path}</td>
                    <td style={td}><span style={{ fontSize: 12, fontWeight: 500, color: sc.color,}}>{r.status_code}</span></td>
                    <td style={{ ...td, fontFamily: 'monospace', fontSize: 12, color: 'var(--ink-2)' }}>{r.ip || '—'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 14 }}>
        <span style={{ fontSize: 13, color: 'var(--ink-2)' }}>
          {total > 0 ? `${offset + 1}–${Math.min(offset + LIMIT, total)} de ${total}` : '0 registros'}
        </span>
        <div style={{ display: 'flex', gap: 8 }}>
          <button disabled={offset === 0 || loading} onClick={() => load(Math.max(0, offset - LIMIT))}
            style={{ padding: '8px 14px', background: 'var(--surface)', border: '1px solid var(--border-2)', borderRadius: 8, fontSize: 13, cursor: offset === 0 ? 'not-allowed' : 'pointer', opacity: offset === 0 ? 0.5 : 1 }}>
            Anterior
          </button>
          <button disabled={offset + LIMIT >= total || loading} onClick={() => load(offset + LIMIT)}
            style={{ padding: '8px 14px', background: 'var(--surface)', border: '1px solid var(--border-2)', borderRadius: 8, fontSize: 13, cursor: (offset + LIMIT >= total) ? 'not-allowed' : 'pointer', opacity: (offset + LIMIT >= total) ? 0.5 : 1 }}>
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
}
